import { selectPreferredPoiIds, selectFilters, searchPois, selectPreferredPoiById } from './poisSlice';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PoiList from './PoiList';
import Navbar from '../../app/Navbar';
import { useHistory } from 'react-router';



const PreferredPoisPage = () => {
    const poiIds = useSelector(selectPreferredPoiIds);
    const poiStatus = useSelector(state => state.pois.preferredPois.status);
    const error = useSelector((state) => state.pois.preferredPois.error);
    const history = useHistory();
    const goBack = (event) => {
        event.preventDefault();
        history.goBack();
    };
    const currentFilters = useSelector(selectFilters);
    const dispatch = useDispatch();
    const loadMore = () => {
        let offset = (typeof currentFilters.offset === 'undefined') ? 0 : currentFilters.offset;
        offset += currentFilters.limit;
        dispatch(searchPois({
            ...currentFilters,
            offset: offset
        }));
    };

    return <div id="search_poi_page">
        <PoiList poiIds={poiIds} status={poiStatus} error={error} onGoBack={goBack} onLoadMore={loadMore} selectById={selectPreferredPoiById}/>
        <Navbar/>
    </div>
};

export default PreferredPoisPage;